
const BASE_URL = process.env.REACT_APP_API_URL

const fetchStories = async () => {
    try {
        const response = await fetch(BASE_URL + "/stories/getAllStories")
        const data = await response.json()
        return data
    } catch (error) {
        console.log(error)
    }
}

const addStory = async (header, content, images) => {
    if (header.trim() === "" || content.trim() === "") {
        return
    }

    const formData = new FormData()
    formData.append("header", header)
    formData.append("content", content)

    images.forEach((image, index) => {
        const uniqueFileName = `${Date.now()}_${index}_${image.name}`;
        const renamedFile = new File([image], uniqueFileName, { type: image.type });
        console.log("Unigue name: ", uniqueFileName)
        formData.append("images", renamedFile);
    });


    try {
        const response = await fetch(BASE_URL + "/stories/addStory", {
            method: "POST",
            body: formData,
        })

        const data = await response.json()
        console.log("response:", typeof(data),data)

    } catch (error) {
        console.log(error)
    }
}


const removeStory = async (id, header) => {
    try {
        const response = await fetch(BASE_URL + "/stories/deleteStory/" + id, {
            method: "DELETE",
        })
        console.log(response)
        if (response.ok) {
            return { status: "ok" }
        } else {
            const errorData = await response.json()
            return { status: "error", error: errorData }
        }
    } catch (error) {
        console.error(error)
        return { status: "error", error: error.message }
    }
}

const updateStory = async (id, header, content) => {

    if (header.trim() === "" || content.trim() === "") {
        return
    }

    try {
        const response = await fetch(BASE_URL + "/stories/updateStory/" + id, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ header, content }),
        })

        const data = await response.json()

        return data

    } catch (error) {
        console.log(error)
    }
}

export { fetchStories, addStory, removeStory, updateStory }